import React from "react";
import PropTypes from "prop-types";

import BedIcon from "../../static/icons/bed.svg";
import BathIcon from "../../static/icons/bath.svg";
import AreaIcon from "../../static/icons/area.svg";

const PropertyButtons = (props) => {
    const { listing, css } = props;

    return (
        <div className={css.basic}>
            {listing.bedrooms > 0 && (
                <div>
                    <BedIcon /> <span>{listing.bedrooms} Beds</span>
                </div>
            )}

            {listing.bathrooms > 0 && (
                <div>
                    <BathIcon /> <span>{listing.bathrooms} Bath</span>
                </div>
            )}

            {listing.living_area > 0 && (
                <div>
                    <AreaIcon /> <span>{listing.living_area} sqft</span>
                </div>
            )}
        </div>
    );
};

PropertyButtons.propTypes = {
    listing: PropTypes.object.isRequired,
    css: PropTypes.object.isRequired,
};

export default PropertyButtons;
